<h2 class="card-title"><slot /></h2>
